import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
  private static readonly DEFAULT_ERROR_DURATION_MS = 2500;

  constructor(
    public snackBar: MatSnackBar,
    readonly zone: NgZone) { }

  showSuccess(message: string): void {
    // Had an issue with the snackbar being ran outside of angular's zone.
    this.zone.run(() => {
      this.snackBar.open(message);
    });
  }

  dismissBar(){
    this.snackBar.dismiss();
  }

  showError(message: string,time=NotificationService.DEFAULT_ERROR_DURATION_MS): void {
    this.zone.run(() => {
      // The second parameter is the text in the button. 
      // In the third, we send in the css class for the snack bar.
      this.snackBar.open(message, 'X', {panelClass: ['error']});
      setTimeout(() => {
        this.snackBar.dismiss();        
      }, time);
     
    });
  }

  showTokenUpdate(message : string, time = 2500) : void{
    this.zone.run( () => {
      this.snackBar.open(message, '' ,{panelClass : ['tokenUpdate']});
    });
    setTimeout( () => {
      this.snackBar.dismiss();
    }, time);
  }
}